import { ref, onMounted } from '@vue/composition-api'
import store from '@/store'

export default function useUsersList() {
  const usersSelectList = ref([])
  const FetchUsers = () => {
    usersSelectList.value = []
    store
      .dispatch('users/apiCall', {
        mode: 'Select',
        request: {
          all: process.env.VUE_APP_API_ALL,
          srt: 'name',
          desc: false,
        },
      })
      .then(response => {
        if (response.success) {
          usersSelectList.value = response.data.items
        }
      })
  }
  onMounted(() => {
    FetchUsers()
  })

  return {
    usersSelectList,
  }
}
